import FJModalItem from '../../../common/components/FJModalItem/FJModalItem';
import styles from './FJModalList.module.less';
import FJVerticalScroller from '../../../common/components/FJScroller/FJVerticalScroller';
import PropTypes from 'prop-types';
import FJLocalStore from '../../../store/FJLocalStore';
import { useRef, useEffect, useCallback } from 'react';
import { STYLE_LIST } from '../../../config/dataConfig/FJImageToImageData';
import FJHorizontalScrollTab from '../../../common/components/FJTab/FJHorizontalScrollTab';
import FJConfig from '../../../config/FJConfig';
import classNames from 'classnames';
const styleTabList = STYLE_LIST.map(i => ({ type: i.categoryName, text: i.categoryName }));
const FJModalList = props => {
    const { list = [], onChange, value, selectStyleCategory, setSelectStyleCategory, id } = props;
    const scrollRef = useRef(null);
    const categoryRef = useRef([]);
    const _isScrollingRef = useRef(false);
    const _scrollingTimerRef = useRef(null);
    const _tabScrollRef = useRef(null);

    const _onScroll = () => {
        if (!scrollRef.current || !categoryRef.current || _isScrollingRef.current) return;
        const scrollDom = scrollRef.current.getScroller();
        const scrollRect = scrollDom.getBoundingClientRect();
        for (let i = 0; i < categoryRef.current.length; i++) {
            const rect = categoryRef.current[i].parentElement.getBoundingClientRect();
            if (rect.top <= scrollRect.top && rect.bottom > scrollRect.top) {
                setSelectStyleCategory(i);
                break;
            }
        }
    };
    const _onTabChange = useCallback(
        idx => {
            setSelectStyleCategory(idx);
            if (!scrollRef.current || !categoryRef.current) return;
            const category = categoryRef.current[idx];
            if (category) {
                const rect = category.getBoundingClientRect();
                const scrollDom = scrollRef.current.getScroller();
                const scrollRect = scrollDom.getBoundingClientRect();
                const scrollTop = scrollDom.scrollTop + rect.top - scrollRect.top;
                scrollRef.current.scrollTop(scrollTop, 'smooth');
                _isScrollingRef.current = true;
                clearTimeout(_scrollingTimerRef.current);
                _scrollingTimerRef.current = setTimeout(() => {
                    _isScrollingRef.current = false;
                }, 1000);
            }
        },
        [setSelectStyleCategory],
    );
    useEffect(() => {
        const index = STYLE_LIST.findIndex(category => category.list.find(item => item.value === value));
        _onTabChange(index);
        _tabScrollRef.current && _tabScrollRef.current.updateArrowState();
        //仅页面加载调用
    }, [_onTabChange]);
    return (
        <div id={id} className={classNames(styles.box)}>
            <FJHorizontalScrollTab
                dataList={styleTabList}
                selectedIndex={selectStyleCategory}
                space={6}
                onTabChange={_onTabChange}
                className={styles.style_tab}
                itemClassName={styles.style_tab_item}
                selectClassName={styles.tab_select}
                lineClassName={styles.line}
                textClassName={styles.tab_text}
                ref={_tabScrollRef}
            />
            <FJVerticalScroller className={classNames(styles.scroll)} ref={scrollRef} onScroll={_onScroll}>
                {list.length > 0 &&
                    list.map((category, index) => {
                        return (
                            <div key={category.categoryName}>
                                <div className={styles.category} ref={ref => (categoryRef.current[index] = ref)}>
                                    {/* <PurpleStarIcon /> */}
                                    <span className={styles.category_name}>
                                        {FJLocalStore._(category.categoryName)}
                                    </span>
                                </div>
                                <div className={styles.list_box}>
                                    {category.list.map(item => (
                                        <FJModalItem
                                            key={item.uniqueKey}
                                            imgSrc={FJConfig.stylePath + item.img + `?v=${FJConfig.version}`}
                                            name={FJLocalStore._(item.name)}
                                            isHot={item.isHot}
                                            isNew={item.isNew}
                                            isPro={item.isPro}
                                            selected={item.value === value}
                                            onClick={() => {
                                                onChange(item.value);
                                            }}
                                        />
                                    ))}
                                </div>
                            </div>
                        );
                    })}
            </FJVerticalScroller>
        </div>
    );
};
FJModalList.propTypes = {
    selectStyleCategory: PropTypes.number,
    list: PropTypes.array,
    onChange: PropTypes.func,
    value: PropTypes.string,
    setSelectStyleCategory: PropTypes.func,
    openPromptInput: PropTypes.bool,
    id: PropTypes.string,
};
export default FJModalList;
